export default "__VITE_ASSET__d091691e__"